import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { APP_NAV, USER_ACTIONS_NAV } from "routes/APP_ROUTES";
import { cn } from "helper/Utils";
import { formattedTimeZone, formatToTwoDecimalPlaces, isImageUrl } from "helper/Functions";
import { useAuth } from "provider/AuthContext";

import { FaBars, FaWallet } from "react-icons/fa";
import Logo from "assets/images/logo.jpg";
import { UserActionsDropdown } from "./UserActionsDropdown";
import { MdClose } from "react-icons/md";
import { useUserSettings } from "provider/UserSettingsContext";
import { IoCloseOutline } from "react-icons/io5";
import { UserLanguageDropdown } from "./UserLanguageDropdown";
import { useTranslation } from "react-i18next";
import { useSportsbook } from "provider/SportsbookContext";

const AppHeader = ({ onLoginClick, isSidebarOpen, toggleSidebar, onRegisterClick }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { user } = useAuth();
  const { sendMessageToSportsbook } = useSportsbook();
  const { setIsUserActionModalOpen, isUserActionModalOpen, handleUserSettingMenuItemClick, handleUserSettingModalClose } = useUserSettings();

  const [isMobile, setIsMobile] = useState(window?.innerWidth <= 768);

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
  );

  const isUserRole = user?.role === "User";

  // const [isUserActionModalOpen, setIsUserActionModalOpen] = useState(false);
  // const [selectedTab, setSelectedTab] = useState(null);

  // const handleUserSettingMenuItemClick = (tab) => {
  //   setIsUserActionModalOpen(true);
  //   setSelectedTab(tab);
  // };

  // const handleUserSettingModalClose = () => {
  //   setIsUserActionModalOpen(false);
  //   setSelectedTab(null);
  //   navigate("/");
  // };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(
        new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
      );
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const userNavItems = APP_NAV();
  const userActionNavItems = USER_ACTIONS_NAV();

  const userBasedNavItems = (user && isUserRole) || !user ? userNavItems : [];
  return (
    <>
      <style jsx="true">
        {`
          header ul li {
            border-right: 1px solid rgba(255, 255, 255, 0.1);
            padding: 0 8px;
            display: flex;
            align-items: center;
          }
          @media screen and (max-width: 768px) {
            header ul li {
              border-right: none;
              padding: 0;
            }
          }
        `}
      </style>
      <header className={cn("text-white bg-body md:px-2 md:pt-1 sticky top-0 z-40", isMobile && isUserActionModalOpen ? "z-[1002]" : "z-40")}>
        <div className="flex flex-wrap items-center p-0">
          {/* Left Section */}
          <Link to="/" onClick={handleUserSettingModalClose} className="h-[48px] max-w-[100px] md:max-w-[200px] ml-[0.4rem] flex items-center">
            <img className=" w-full logo-animation" src={Logo} alt="logo" />
            {/* <img className="h-[48px]" src="https://vbet.com/logo.jpg?v=1718789054" alt="logo" /> */}
          </Link>
          {/* <img onClick={() => (window.location.href = "/promotions")} className="md:h-[30px] h-[24px] md:ml-6 ml-3" src={IconGift} alt="logo" /> */}
          <div className="flex flex-wrap items-center md:p-0 ml-auto md:w-auto w-full md:border-0 border-y border-[rgb(45,62,97,0.3)]">
            {/* <ul
              className={cn(
                "flex md:justify-end justify-between items-center md:w-auto w-full md:p-0 p-2",
                isMobile && isUserActionModalOpen ? "hidden" : ""
              )}
            >
              {/* <li className="flex gap-2 items-center">
                <span className="w-6 h-6 rounded-lg bg-primary flex items-center justify-center">
                  <TiFlash className={cn(isMobile ? "text-white " : "text-body")} size={20} />
                </span>

                <Link to="#" className="text-white leading-[14px] text-[12px] flex flex-col">
                  <span>1 FTN = 3.3399 USDT</span>
                  <span>exchange.fulgurpay.com</span>
                </Link>
              </li> 
              <li className="flex gap-2">
                <button className=" bg-[#109121] rounded flex items-center justify-center md:pl-3 md:pr-3 h-[28px] min-w-[28px] text-[14px] font-medium">
                  <span className="md:block hidden">OCCURSUM</span>
                  <span className="block md:hidden">
                    <FaUserFriends />
                  </span>
                </button>
                {user && (
                  <>
                    <div className="border-r border-[rgb(45,62,97,0.3)] h-[28px] md:inline-block hidden"></div>
                    <button className="bg-[#109121] rounded flex items-center justify-center md:pl-3 md:pr-3 h-[28px] min-w-[28px] text-[14px] font-medium">
                      <span className="md:block hidden">CONNECT TO WALLET</span>
                      <span className="block md:hidden">
                        <i className="bc-i-connect-wallet" />
                      </span>
                    </button>
                  </>
                )}
              </li>
            </ul> */}
            <ul className={cn("flex items-center md:relative md:top-0 md:right-0 absolute gap-2 top-2 right-2")}>
              {user ? (
                <>
                  {/* Close button visible only on mobile when isUserActionModalOpen is true */}
                  {isMobile && isUserActionModalOpen && (
                    <>
                      <button
                        onClick={handleUserSettingModalClose}
                        className={`text-slate-400 leading-none rounded-lg top-2 right-2 outline-none focus:outline-none fixed w-9 h-9 md:hidden flex justify-center items-center`}
                      >
                        <MdClose className="text-gray-400 w-[24px] hover:text-[#fff]" size={30} />
                      </button>
                    </>
                  )}

                  {/* Always-visible section, hidden on mobile when isUserActionModalOpen is true */}
                  {(!isMobile || !isUserActionModalOpen) && (
                    <>
                      <button
                        className=" bg-[#109121] rounded flex items-center justify-center md:pl-3 md:pr-3 h-[28px] min-w-[28px] text-[14px] font-medium"
                        onClick={() => handleUserSettingMenuItemClick("balanceManagementDeposit")}
                      >
                        <span className="md:block hidden uppercase">{t("deposit")}</span>
                        <span className="block md:hidden">
                          <FaWallet />
                        </span>
                      </button>
                      <li>
                        {user && !isUserRole ? (
                          <Link
                            to="/admin/transfer"
                            className="bg-primary rounded flex items-center justify-center md:pl-3 md:pr-3 md:h-[28px] min-w-[28px] md:text-[14px] text-[12px] md:p-0 p-1 font-medium"
                          >
                            {user && user?.role ? user?.role : "Guest"}
                          </Link>
                        ) : null}
                      </li>

                      {/*<button type="button" className={cn("text-white min-h-[28px] py-1 px-2 rounded text-[11px] flex items-center")}>*/}
                      {/*  Bonus: {formatToTwoDecimalPlaces(user?.bonus_balance ? user?.bonus_balance : 0)} TND*/}
                      {/*</button>*/}
                      <UserActionsDropdown
                        toggleBtnClasses="-mx-2"
                        menuItemsClasses="pt-2"
                        label={
                          <>
                            <span className="flex flex-col text-[12px]">
                              {formatToTwoDecimalPlaces(user?.balance)} {user?.currency}
                              <small>
                                Bonus: {formatToTwoDecimalPlaces(user?.bonus_balance ? user?.bonus_balance : 0)} {user?.currency}
                              </small>
                            </span>
                          </>
                        }
                        menuData={userActionNavItems?.find((fi) => fi.key === "balanceManagementDeposit")?.child || []}
                        handleUserSettingMenuItemClick={handleUserSettingMenuItemClick}
                      />
                      {isMobile ? (
                        <i
                          className="bc-i-user text-[28px] drop-shadow-[0 0 12px #ff3449, 0 0 20px #ff3449]"
                          onClick={() => {
                            setIsUserActionModalOpen(false);
                            handleUserSettingMenuItemClick(null);
                          }}
                        />
                      ) : (
                        <UserActionsDropdown
                          dropdownType="user"
                          toggleBtnClasses="-mx-2"
                          label={<i className="bc-i-user text-[28px] drop-shadow-[0 0 12px #ff3449, 0 0 20px #ff3449]" />}
                          menuData={userActionNavItems}
                          handleUserSettingMenuItemClick={handleUserSettingMenuItemClick}
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <li className="flex gap-2">
                  <button
                    onClick={() => onLoginClick()}
                    className=" underline text-[12px] py-1 rounded-lg  hover:border-primary-yellow transition-all"
                  >
                    {t("Login")}
                  </button>
                  <button onClick={() => onRegisterClick()} className="bg-primary text-white px-3 h-[28px] rounded text-[12px]">
                    REGISTER
                  </button>
                </li>
              )}
              <li>
                <span className="md:flex items-center hidden bg-[rgb(25,38,59)] text-white px-3 h-[28px] rounded text-[12px]">{currentTime}</span>
              </li>
              {!isMobile ||
                (!isUserActionModalOpen && (
                  <li className="border-0">
                    <span className="md:flex items-center bg-[rgb(25,38,59)] text-white h-[28px] rounded text-[12px]">
                      <UserLanguageDropdown />
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <nav
          className={cn(
            "flex items-end md:bg-[#263045] md:rounded-md overflow-x-auto md:mt-1 hide-scrollbar sm:border-0 border-b border-white/10",
            isMobile && isUserActionModalOpen ? "hidden" : ""
          )}
        >
          {userBasedNavItems.map((item, index) => {
            return (
              <NavLink
                key={index}
                to={isUserRole || !user ? item.path : "/admin" + item.path}
                onClick={() =>
                  item.path === "/sportsbook/sports"
                    ? sendMessageToSportsbook({ changePage: "sport" })
                    : item.path === "/sportsbook/live"
                    ? sendMessageToSportsbook({ changePage: "live" })
                    : null
                }
                className={cn(
                  "flex items-center gap-2 sm:py-[5px] py-[8px] px-5 sm:border-t-2 border-b-2 border-transparent text-nowrap lg:text-[16px] text-[15px] text-white/80 sm:hover:border-t-[#e3910a] hover:bg-body [&.active]:text-white sm:[&.active]:bg-[#e3910a] [&.active]:border-[#e3910a] shadow-sm [&.active]:shadow-primary [&_svg_path]:fill-white/80"
                  // index > 2 && location.pathname.split("/")[1] === item.path.split("/")[1]
                  //   ? "active"
                  //   : index < 2 && location.pathname.split("/")[2] === item.path.split("/")[2]
                  //   ? "active"
                  //   : ""
                  // childLinks ? "md:flex" : ""
                )}
              >
                <span className="md:flex hidden leading-none">
                  {isImageUrl(item.iconHeader || item.image) ? (
                    <img src={item.iconHeader || item.image} alt={item.label || item.title} />
                  ) : (
                    item.iconHeader || item.image
                  )}
                </span>
                {item.label || item.title}
              </NavLink>
            );
          })}
        </nav>
        {/* {childLinks ? (
          <nav className="flex md:justify-center justify-start md:space-x-5 overflow-x-auto md:mt-1 -mx-2 border-b border-b-[rgb(45,62,97,0.3)]">
            {childLinks.map((item) => (
              <NavLink
                key={item.id}
                to={item.path}
                className={cn(
                  "bg-body md:normal-case uppercase flex md:flex-none flex-auto md:gap-2 justify-center items-center lg:text-[17px] text-[12px] text-nowrap text-white/60 hover:border-b-[#e3910a] hover:text-white border-b-2 border-transparent ",
                  "p-3 px-4 md:gap-2 md:p-[5px]",
                  "md:[&.active]:border-r-0 [&.active]:text-white [&.active]:border-b-[#e3910a] md:border-r-0 border-r-[.25px] [&.active:first-of-type]:border-r-[#e3910a] [&.active:first-child]:sticky left-0"
                )}
              >
                <span className="md:flex  hidden leading-none">{isImageUrl(item.icon) ? <img src={item.icon} alt={item.label} /> : item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </nav>
        ) : null} */}

        {/* Header Bottom Spacer */}
        {isMobile && !isUserActionModalOpen ? <div className="bg-body h-[8px]"></div> : !isMobile ? <div className="bg-body h-[8px]"></div> : null}
        {/* Header Bottom Spacer */}
      </header>
      {isMobile && user && !isUserRole && location.pathname.includes("/admin") && (
        <div className="p-5 text-white">
          <div className="flex justify-between">
            <div className="flex flex-col justify-start float-start gap-1">
              <p className="text-lg font-semibold">AGENT MENU</p>
              <p className="text-sm flex-row space-x-1 rtl:space-x-reverse opacity-70">{formattedTimeZone()}</p>
            </div>

            <button onClick={() => toggleSidebar(!isSidebarOpen)} className="text-white focus:outline-none mr-3">
              {isSidebarOpen ? <IoCloseOutline size={40} /> : <FaBars size={30} />}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AppHeader;
